import { gql, useMutation } from '@apollo/client';

import { GET_ABSENCE_REASONS_BY_COMPANY } from './get-absence-reasons-by-company.hook';

const CREATE_ABSENCE_REASONS = gql`
  mutation createAbsenceReasons($payload: [CreateAbsenceReasonInput!]!) {
    createAbsenceReasons(payload: $payload) {
      _id
    }
  }
`;

export const useCreateAbsenceReasons = () => {
  const [createAbsenceReasons] = useMutation(CREATE_ABSENCE_REASONS, {
    refetchQueries: [GET_ABSENCE_REASONS_BY_COMPANY],
  });

  return createAbsenceReasons;
};
